import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-secondary-950">
      <div className="w-full px-4 md:px-6 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
          准备好加入17c一起了吗？
        </h2>
        <p className="text-sm md:text-base text-background-300 mb-8 leading-relaxed">
          发现更多共同兴趣，开启全新社交体验。<br />
          和志同道合的伙伴一起行动、一起分享、一起成长。
        </p>
        <Link
          to="/about"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="inline-block bg-primary-500 text-background-50 px-10 py-3 rounded-full text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
        >
          立即加入
        </Link>
      </div>
    </section>
  );
}